export const CHECK_SOLUTION = 'CHECK_SOLUTION';
export const CREATE_GRID = 'CREATE_GRID';
export const DESELECT_BLOCK = 'DESELECT_BLOCK';
export const EDIT_BLOCK_NOTES = 'EDIT_BLOCK_NOTES';
export const SELECT_BLOCK = 'SELECT_BLOCK';
export const SET_BLOCK_VALUE = 'SET_BLOCK_VALUE';
export const TOGGLE_NOTES_MODE = 'TOGGLE_NOTES_MODE';
